import React, { useState, useRef } from "react";
import { createNotification } from "../helpers/Notification";
import Loader from "../common/Loader";
import { checkValidPasswpord } from "../helpers/Util";
import SimpleReactValidator from "simple-react-validator";
import { useDispatch, useSelector } from "react-redux";
import { setLoginUserData } from "../project/redux/projectAction";
import projectServices from "../project/services/projectServices";
import { useNavigate } from 'react-router-dom';

const ChangePassword = () => {
  const [state, setState] = useState({
    oldPassword: "",
    password: "",
    confirmPassword: "",
    loader: false,
  });
  const validator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const loginUserData = useSelector(state => state.loginUserData);

  const handleOnChange = (event) => {
    const { name, value } = event.target;
    setState(prev => ({ ...prev, [name]: value }));
  };

  const changePassword = () => {
    const { oldPassword, password, confirmPassword } = state;
    if (validator.current.allValid()) {
      if (password !== "" && confirmPassword !== password) {
        createNotification(
          "info",
          "Confirm Password and Password do not match!"
        );
        return false;
      } else if (
        password !== "" &&
        confirmPassword !== "" &&
        !checkValidPasswpord(password)
      ) {
        createNotification(
          "info",
          "Passwords must be 8 to 15 characters which contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character!"
        );
        return false;
      }
      let payload = { oldPassword, password, confirmPassword };
      setState(prev => ({ ...prev, loader: true }));
      projectServices
        .updatePasswordByToken(payload)
        .then((res) => {
          if (res.data.status) {
            createNotification("success", "Password changed successfully");
            setState(prev => ({ ...prev, loader: false }));
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            createNotification(
              "error",
              "Your login session has been expired!"
            );
            localStorage.clear();
            navigate("/login");
            setState(prev => ({ ...prev, loader: false }));
          } else {
            let errMsg = 'An error occurred';
            if (error.response?.data?.message) {
              errMsg = Array.isArray(error.response.data.message) 
                ? error.response.data.message[0] 
                : error.response.data.message;
            } else if (error.response?.data?.message) {
              errMsg = error.response.data.message;
            }
            createNotification("error", errMsg);
            setState(prev => ({ ...prev, loader: false }));
          }
        });
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  const { loader, oldPassword, password, confirmPassword } = state;

  return (
    <div>
      {loader ? (
        <Loader />
      ) : (
        <div className="main-content addUser-form">
          <div className="page-content">
            <div className="container-fluid">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0">Change Password</h4>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="card card-block">
                    <div className="card-body">
                      <div className="wizard clearfix">
                        <div className="content clearfix">
                          <form className="form-project ">
                            <div className="row"></div>
                            <div className="row">
                              <div className="col-md-4 col-sm-12">
                                <div className="mb-3">
                                  <label className="form-label" htmlFor="validationCustom01">
                                    Old Password <span style={{ color: "red" }}> *</span>
                                  </label>
                                  <input
                                    type="password"
                                    className="form-control"
                                    value={oldPassword}
                                    name="oldPassword"
                                    onChange={handleOnChange}
                                    placeholder="Old Password"
                                    required
                                  />
                                  {validator.current.message(
                                    "oldPassword",
                                    oldPassword,
                                    "required|max:50",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-4 col-sm-12">
                                <div className="mb-3">
                                  <label className="form-label" htmlFor="validationCustom02">
                                    New Password <span style={{ color: "red" }}> *</span>
                                  </label>
                                  <input
                                    type="password"
                                    className="form-control"
                                    id="validationCustom02"
                                    name="password"
                                    onChange={handleOnChange}
                                    placeholder="New Password"
                                    required
                                  />
                                  {validator.current.message(
                                    "New password",
                                    password,
                                    "required|max:50",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                              <div className="col-md-4 col-sm-12">
                                <div className="mb-3">
                                  <label className="form-label" htmlFor="validationCustom02">
                                    Confirm Password <span style={{ color: "red" }}> *</span>
                                  </label>
                                  <input
                                    type="password"
                                    className="form-control"
                                    id="validationCustom02"
                                    name="confirmPassword"
                                    onChange={handleOnChange}
                                    placeholder="Confirm Password"
                                    required
                                  />
                                  {validator.current.message(
                                    "confirmPassword",
                                    confirmPassword,
                                    "required|max:50",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div className="actions clearfix">
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light"
                            onClick={changePassword}
                          >
                            <i className="uil uil-save"></i> Update
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChangePassword;
